import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UnitMeasureState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: UnitMeasureState = {
  data: [],
  isLoading: false,
  error: null,
};

const unitMeasureSlice = createSlice({
  name: 'unitMeasure',
  initialState,
  reducers: {
    setUnitMeasures: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setUnitMeasureLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setUnitMeasureError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  setUnitMeasures: setUnitMeasures,
  setUnitMeasureLoading,
  setUnitMeasureError,
} = unitMeasureSlice.actions;

export default unitMeasureSlice.reducer;
